import { SurveyPayload } from '../../shared/interfaces/survey-meta-data.interface';

export class UniqueLinksValidator {
  constructor(
    private readonly expected_ir: number,
    private readonly completes_required: number,
    private readonly unique_links: NonNullable<SurveyPayload['unique_links']>
  ) {}

  static from(survey: SurveyPayload) {
    if (!survey.unique_links) {
      throw new Error('Unique Links must be valid!');
    }

    return new UniqueLinksValidator(
      survey.expected_ir,
      survey.completes_required,
      survey.unique_links!
    );
  }

  public validate(): boolean {
    return this.unique_links.items.length >= this.requiredUniqueLinks();
  }

  public requiredUniqueLinks(): number {
    return Math.floor((this.completes_required / this.expected_ir) * 100);
  }
}
